import React from "react";
import { useHits } from "react-instantsearch";
import _ from "lodash";
import BoardCard from "../../Cards/BoardCard";
import IconButton from "@mui/material/IconButton";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { useBackofficeUser } from "../../../provider/BackofficeUserProvider";
import { legalbirdHitsStyles } from "./legalbirdHitsStyles";
import { Box, IconButtonProps, Stack } from "@mui/material";
import { CaseHit } from "../../Case/CaseEntityPicker/Hit/hitType";
import { CarouselProvider } from "../../Carousel/CarouselProvider.tsx";
import { CarouselSlides } from "../../Carousel/CarouselSlides.tsx";
import { CarouselSlide } from "../../Carousel/CarouselSlide.tsx";
import { CarouselArrow } from "../../Carousel/CarouselArrow.tsx";

type CustomArrowProps = {
  onClick?: IconButtonProps["onClick"];
  direction: string;
};

const CustomArrow = ({ onClick, direction }: CustomArrowProps) => {
  function isValidStyleName(styleName: string): styleName is keyof typeof legalbirdHitsStyles {
    return styleName in legalbirdHitsStyles;
  }

  const directionStyleName = direction + "Arrow";
  if (!isValidStyleName(directionStyleName)) {
    return <></>;
  }

  return (
    <IconButton
      onClick={(e) => onClick && onClick(e)}
      sx={[legalbirdHitsStyles[directionStyleName], legalbirdHitsStyles.arrowColors]}
      size="large"
    >
      {direction === "right" ? <ArrowRight /> : <ArrowLeft />}
    </IconButton>
  );
};

type LegalbirdHitsProps = {
  stages: Record<string, any>;
};

type BoardHit = CaseHit & {
  objectID: string;
};

const LegalbirdHits = ({ stages }: LegalbirdHitsProps) => {
  const { items } = useHits<BoardHit>();
  const partitionHits = _.groupBy(items, (item) => item.stage);
  const { backofficeUsers } = useBackofficeUser();

  return (
    <Stack sx={legalbirdHitsStyles.carouselContainer}>
      <CarouselProvider>
        <Stack direction={"row"}>
          <CarouselArrow
            type={"previous"}
            sx={{ flexShrink: 0, left: "1rem", ...legalbirdHitsStyles.carouselArrow }}
            hideIfDisabled
          />
          <Box sx={{ width: "100%" }}>
            <CarouselSlides>
              {_.map(stages, (stage, stageId) => {
                const partition = partitionHits[stageId] || [];
                return (
                  <CarouselSlide sx={legalbirdHitsStyles.carouselSlide} key={stageId}>
                    <Box sx={legalbirdHitsStyles.columnLabel}>{stages[stageId].label}</Box>
                    <Box sx={legalbirdHitsStyles.caseCount}>
                      {partition.length} {partition.length === 1 ? "Fall" : "Fälle"}
                    </Box>
                    {_.map(partition, (hit) => {
                      return <BoardCard key={hit.objectID} hit={hit} backofficeUsers={backofficeUsers} />;
                    })}
                  </CarouselSlide>
                );
              })}
            </CarouselSlides>
          </Box>
          <CarouselArrow
            type={"next"}
            sx={{ flexShrink: 0, right: "1rem", ...legalbirdHitsStyles.carouselArrow }}
            hideIfDisabled
          />
        </Stack>
      </CarouselProvider>
    </Stack>
  );
};

export default LegalbirdHits;
